import React, { useContext, useState, useEffect, useRef } from "react";
import {
  DispatchContext,
  StateContext,
} from "bodycodi/cmap/app/components/cmap2010/calendar/calendar";
import { addZero, isEmpty } from "bodycodi/cmap/app/js/common.js";

import BottomDots from "bodycodi/cmap/app/components/cmap2010/calendar/BottomDots";

type GradCalendarProp = {
  clndrDate: string;
  isActive: boolean;
  chooseDate: any;
};

const GradCalendar = ({ clndrDate, isActive, chooseDate }: GradCalendarProp) => {
  const week = ["일", "월", "화", "수", "목", "금", "토"];
  const [clndrDateArray, setClndrDateArray] = useState([]);
  const { dispatch: calendarDispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { onClick, scheduletStateList, holidays, isAddStep, activeClndrDate } = state;
  const calendar = useRef<HTMLDivElement>(null);

  const selectedDate = {
    year: chooseDate?.year || new Date().getFullYear(),
    month: chooseDate?.month - 1 || new Date().getMonth(),
    date: chooseDate?.date || new Date().getDate(),
  };

  useEffect(() => {
    if (parseInt(clndrDate.substring(5), 10) !== activeClndrDate.month) return;
    const currentMonth = new Date().getMonth();
    if (activeClndrDate.month === currentMonth) {
      const sliblings = calendar.current?.querySelectorAll(".date-month")!;
      sliblings.forEach(function (t: any) {
        t.classList.remove("active");
      });
      const today = calendar.current?.querySelector(`.d${new Date().getDate()}`);
      today?.classList.add("active");
    } else {
      const sliblings = calendar.current?.querySelectorAll(".date-month")!;
      sliblings.forEach(function (t: any) {
        t.classList.remove("active");
      });
      const firstDay = calendar.current?.querySelector(".d1");
      firstDay?.classList.add("active");
    }
  }, [activeClndrDate]);

  useEffect(() => {
    const clndrDateArray1: any = [];
    const currentFullYear = Number(clndrDate.split("-")[0]);
    const currentMonth = Number(clndrDate.split("-")[1]);
    const lastDate = new Date(currentFullYear, currentMonth + 1, 0).getDate();
    const firstDay = new Date(currentFullYear, currentMonth, 1).getDay();
    const weeks = Math.ceil((lastDate + firstDay) / 7);
    let d = 1;
    for (let i = 0; i < weeks; i++) {
      const weekArray = [];
      for (let j = 0; j < 7; j++) {
        const obj = { closeDate: false, empty: false };
        if (i === 0 && j < firstDay) {
          //달력 공백
          obj.empty = true;
          weekArray.push(obj);
        } else if (d > lastDate) {
          obj.empty = true;
          weekArray.push(obj);
        } else {
          const date = new Date(currentFullYear, currentMonth, d);
          const config: any = {
            year: currentFullYear,
            month: currentMonth + 1,
            date: d,
            day: week[date.getDay()],
          };
          if (
            holidays.includes(d) ||
            (isAddStep &&
              date.getFullYear() === selectedDate.year &&
              date.getMonth() === selectedDate.month &&
              selectedDate.date > d)
          ) {
            config.closeDate = true;
          } else {
            const date = currentFullYear + "-" + addZero(currentMonth + 1) + "-" + addZero(d);
            let state: Array<any> = [];
            if (isActive) {
              if (!isEmpty(scheduletStateList[date])) {
                state = scheduletStateList[date];
              }
              config.state = state;
            }
            config.closeDate = false;
          }
          if (date.getFullYear() === selectedDate.year && date.getMonth() === selectedDate.month) {
            if (date.getDate() === selectedDate.date) {
              config.toDay = true;
              config.active = true;
            } else {
              config.toDay = false;
            }
          } else {
            if (date.getDate() === 1) {
              config.active = true;
            }
            config.toDay = false;
          }
          weekArray.push({ ...obj, ...config });
          d++;
        }
      }
      clndrDateArray1.push(weekArray);
    }
    setClndrDateArray(clndrDateArray1);
    calendarDispatch({ type: "UPDATE", data: { clickDate: state.clickDate + 1 } });
  }, [clndrDate, scheduletStateList, holidays]);

  const clickDate = (d: any) => (e: any) => {
    if (!isEmpty(d.date)) {
      if (!d.closeDate) {
        const sliblings = calendar.current?.querySelectorAll(".date-month")!;
        sliblings.forEach(function (t: any) {
          t.classList.remove("active");
        });
        e.currentTarget.classList.add("active");
        onClick(d);
      }
    }
  };

  const makeClndr = clndrDateArray.map((d: any, i: number) => {
    const list = d.map((d1: any, i: number) => {
      return (
        <div
          key={"date" + i}
          className={
            "date" +
            (!isEmpty(d1.date) ? " date-month d" + d1.date : " ") +
            (d1.closeDate ? " close-date" : "") +
            (d1.toDay ? " to-day" : "") +
            (d1.active ? " active" : "")
          }
          onClick={clickDate(d1)}
        >
          <div>
            {d1.date}
            <BottomDots dots={d1.state} />
          </div>
        </div>
      );
    });
    return (
      <div key={"week" + i} className="week">
        {list}
      </div>
    );
  });

  return (
    <div className="calendar-animation" ref={calendar}>
      {makeClndr}
    </div>
  );
};

export default GradCalendar;
